



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Unit } from '../types';

@Component
export default class Vote extends Vue {


  get selected() {
    return '';
  }

  set selected(value: any) {
    this.$emit('selected', { [this.argument.name.toString()]: value });
  }

  @Prop() public argument!: any;
  private options: any[] = [
    { text: 'Nay', value: 0 },
    { text: 'Aye', value: -1 },
  ];

}
